import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ErrorBoundary from "lib/ErrorBoundary";
import { setPreference } from "components/Preferences/preferencesActions";
import { Row, Col, Container } from "react-bootstrap";
import { PAGINATION_POS, VIEW, BANNER_VISIBILITY  } from "redux/slices/api/initialisePreferences";
import { NumberOfSearchResults } from "components/ToolBar/parts/NumberOfSearchResults";
import { _t } from "app/i18n/i18n";
import { ListView } from "components/ListView/ListView";
import { TileView } from "components/TileView/TileView";
import { FeaturedTileView } from "components/FeaturedPubCard/TileView";
import useIsMobile from "lib/hooks/useIsMobile";
import { PaginationControl } from "components/PaginationControl/PaginationControl";
import { LoadingSpinner } from "lib/Spinner";
import { useGetFirstPreference, useHasPreference } from "api/preferences/useGetPreferences";
import { features } from "app/features";
import { ServiceNotification } from "components/ServiceNotification/ServiceNotification";
import { AdvertBanner } from "pages/Ads/Adverts/AdvertBanner";
import { CoverImageDataProvider } from "components/FeaturedPubCard/CoverImageDataProvider";
import SubscriptionsModal from "components/Subscriptions/SubscriptionsModal/SubscriptionsModal";
import { useQueryParams } from "../../../lib/hooks/useQueryParams";
import { isInternalUser } from "../../../lib/entitlements";
import { Toolbar } from "./toolbar/Toolbar";
import { PillsBar } from "./toolbar/PillsBarRedesign";
import { SidePanel } from "./sidePanel/collaspingPanel/SidePanel";
import "./titlebar.css";

export function ViewLayoutRedesign({ searchResults = [], themeInFocusData }) {
  const [publications, , , aggregations, totalHits] = searchResults;
  const viewMode = useGetFirstPreference(VIEW);
  const isPaginationTop = useHasPreference(PAGINATION_POS, "Top & Bottom");
  const dispatch = useDispatch();
  const setViewMode = (mode) => dispatch(setPreference({ key: VIEW, value: mode }));
  const records = totalHits || 0;
  const isMobile = useIsMobile();
  const isLoading = searchResults?.[1];
  const qs = useQueryParams();
  const hasFreeTextSearchQuery = Object.hasOwn(qs, "q") || Object.hasOwn(qs, "title") ;
  const bannerVisibility = useSelector((state) => state.preferences[BANNER_VISIBILITY])?.[0];
  const shouldShowBanners = !isInternalUser() || !bannerVisibility || bannerVisibility === "Show";

  return (
    <ErrorBoundary>
      <Container fluid className="redesign">
        <Row className="flex-nowrap w-100">
          {!isMobile && <SidePanel aggregations={aggregations} themeInFocusData={themeInFocusData} />}
          <LoadingSpinner className={isLoading ? "d-flex mx-auto pt-5 screen-height" : "d-none"} />
          <Col className={`px-2 overflow-x-hidden ${isLoading ? "d-none" : ""}`}>
            {features.serviceNotifications && features.isBulletin && <ServiceNotification />}
            {isPaginationTop && <PaginationControl records={records} />}
            <PillsBar />
            {shouldShowBanners && <AdvertBanner />}
            {features.isfeaturedResearchVisible && !hasFreeTextSearchQuery && (
              <CoverImageDataProvider>
                <FeaturedTileView searchResults={searchResults} />
              </CoverImageDataProvider>
            )}
            <LatestResearchTitle />
            <Toolbar viewMode={viewMode} setViewMode={setViewMode} searchResults={searchResults} themeInFocusData={themeInFocusData} />
            {viewMode === "List" ? <ListView publications={publications} /> : <TileView publications={publications} />}
            <PaginationControl records={records} />
            <NumberOfSearchResults number={totalHits} className="text-center" />
          </Col>
        </Row>
        <SubscriptionsModal modalTitle={_t("Subscriptions for Nomura Research")} />
      </Container>
    </ErrorBoundary>
  );
}

function LatestResearchTitle({ className = "" }) {
  return (
    <section className="d-flex flex-row align-items-center mb-2 overflow-x-auto title-bar">
      <span className="px-2 title-text">{_t("LATEST RESEARCH")}</span>
    </section>
  );
}

export function NoPublicationsFound() {
  return <center className="m-5 text-muted">{_t("No Publications Found")}</center>;
}
